import React from "react";
import noticeTypeToRussian from "../../../../constants/noticeTypeToRussian";
import DefaultDatePicker from "./DefaultDatePicker";
import NoticeText from "./NoticeText";

const PushSettings = ({ templates }) => {
	return (
		<div style={{ position: "relative" }}>
			<span className="type_name">{noticeTypeToRussian.PUSH}</span>
			<DefaultDatePicker type={"PUSH"} />
			<NoticeText templates={templates} fieldKey="PushTemplateId" />
		</div>
	);
};

export default PushSettings;
